import { createFileRoute } from '@tanstack/react-router'

import { DiscoverChannelsBody } from '@/discover/components/DiscoverChannelsBody/DiscoverChannelsBody'

export const Route = createFileRoute('/_learning/discover/channels/_overview')({
  component: RouteComponent,
})

function RouteComponent() {
  return <DiscoverChannelsBody />
}
